module.exports = __webpack_public_path__ + "static/3-8665088ab0001b95f608dc77b5a32f36.png";